// extracted by mini-css-extract-plugin
export default {"content":"generalDialog_content__SdEGJ"};